const arrowLeft = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><polyline stroke-width="1.5" points="10 12 6 7.96 9.92 4"/></svg>',
};

export { arrowLeft as default };
